export default {
  NONE: 'NONE',
  ACTION_EXCLUDED: 'ACTION_EXCLUDED',
  USER_HID_BANNER: 'USER_HID_BANNER',
  EXCLUDED_ENTRY_POINT: 'EXCLUDED_ENTRY_POINT',
  EXCLUDED_REFERRER: 'EXCLUDED_REFERRER',
  OWP_COOKIE_EXISTS: 'OWP_COOKIE_EXISTS',
  ORDERS_WERE_PLACED: 'ORDERS_WERE_PLACED',
  TEMPORARY_HIDDEN: 'TEMPORARY_HIDDEN',
};
